module.exports = "/static/assets/357955e0e5c857b3400dc6baf539b05d.png";